import { initReactI18next } from 'react-i18next';
import i18next, { i18n } from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from '@assets/i18n/en.json';
import fr from '@assets/i18n/fr.json';
import enCommon from '@common/assets/i18n/en.json';
import frCommon from '@common/assets/i18n/fr.json';
import { Language } from '@common/constants/language';
import { formatLocale } from '@common/utils/i18n';
import { environment, Environments } from '@config/env';

const languages = Object.values(Language);

export const configureI18n = (): i18n => {
  i18next
    // // detect user language
    // // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)

    // pass the i18n instance to the react-i18next components.
    // Alternative use the I18nextProvider: https://react.i18next.com/components/i18nextprovider
    .use(initReactI18next)

    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
      fallbackLng: 'fr',
      supportedLngs: languages,
      debug: environment.env === Environments.Development,
      ns: ['translations'],
      defaultNS: 'translations',
      resources: {
        en: { translations: { ...enCommon, ...en } },
        fr: { translations: { ...frCommon, ...fr } },
      },
      interpolation: {
        escapeValue: false, // set to false for react as it escapes by default
        format: formatLocale,
      },
      detection: {
        order: ['localStorage', 'navigator'],

        lookupLocalStorage: `${environment.storageKey}_lang`,
        lookupFromPathIndex: 0,
      },
    });

  return i18next;
};
